import React, { useState } from "react";
import "./css/simpletheme.css"
import "./css/simpletheme.css"
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { InputGroup, Input, Button } from "reactstrap";

export default function SimpleTheme() {
  const [user, SetUser] = useState(JSON.parse(localStorage.getItem("authUser")).data);
  const [student, SetStudent] = useState({
    name: user.name,
    email: user.email,
    phone: user.mob,
    position: "Front-End Developer",
    desc: "I am a front-end developer with more than 3 years of experience writing html, css, and js. I'm motivated, result-focused and seeking a successful team-oriented company with opportunity to grow.",
    experiences: [{ company: "KlowdBox", addr: "San Fr, CA", duration: "Jan 2011 - Feb 2015", role: "Fr developer", desc: "did This and that" },
    { company: "Akount", addr: "San Monica, CA", duration: "Jan 2011 - Feb 2015", role: "Fr developer", desc: "did This and that" }],
    education: [
      { institution: "Sample Institute of Technology", addr: "San Fr, CA", duration: "Jan 2011 - Feb 2015", degree: "Bachelor of Science", desc: "Computer Science" }
    ],
    projects: [
      {
        name: "DSP",
        description: "I am a front-end developer with more than 3 years of experience writing HTML, CSS, and JS. I'm motivated, result-focused, and seeking a successful team-oriented company with opportunities to grow.",
      },
    ],
    skills: [
      { name: "JavaScript", rating: 0, checked: false },
      { name: "React", rating: 0, checked: false },
      { name: "CSS", rating: 0, checked: false },
      { name: "HTML", rating: 0, checked: false },
      { name: "Node.js", rating: 0, checked: false },
    ],
    interests: ["Football", "Programming"], // Interests added here
  });
  const [newExperience, setNewExperience] = useState({
    company: "",
    addr: "",
    duration: "",
    role: "",
    desc: ""
  });
  const [editing, setEditing] = useState({
    name: false,
    email: false,
    phone: false,
    position: false,
    desc: false,
  });
  const [newInterest, setNewInterest] = useState("");

  const [newSkill, setNewSkill] = useState({ name: "", rating: 0, checked: false });

  const [editingProjectIndex, setEditingProjectIndex] = useState(null);
  const [newProject, setNewProject] = useState({ name: "", description: "" });

  const [editingIndex, setEditingIndex] = useState(null);
  const [newEducation, setNewEducation] = useState({ institution: "", addr: "", duration: "", degree: "", desc: "" });
  const [editingEducationIndex, setEditingEducationIndex] = useState(null);
  const handleExperienceChange = (e, field, index) => {
    const updatedExperiences = [...student.experiences];
    updatedExperiences[index][field] = e.target.value;
    SetStudent({ ...student, experiences: updatedExperiences });
  };


  const handleEditClickInd = (index) => {
    setEditingIndex(index);
  };
  const handleSaveClickInd = () => {
    setEditingIndex(null);
  };
  const handleEditClick = (field) => {
    setEditing({ ...editing, [field]: true });
  };

  const handleSaveClick = (field) => {
    setEditing({ ...editing, [field]: false });
    // Save changes to user state or perform any necessary updates here
  };

  const handleChange = (e, field) => {
    SetStudent({ ...student, [field]: e.target.value });
  };
  const handleAddExperienceChange = (e, field) => {
    setNewExperience({ ...newExperience, [field]: e.target.value });
  };

  const handleAddExperience = () => {
    if (Object.values(newExperience).some(x => x === "")) {
      return; // Prevent adding if any field is empty
    }
    SetStudent({
      ...student,
      experiences: [...student.experiences, newExperience]
    });
    setNewExperience({ company: "", addr: "", duration: "", role: "", desc: "" }); // Reset input fields
  };

  const handleDeleteExperience = (index) => {
    const updatedExperiences = student.experiences.filter((_, i) => i !== index);
    SetStudent({ ...student, experiences: updatedExperiences });
  };


  // Education Functions
  const handleEducationChange = (e, field, index) => {
    const updatedEducation = [...student.education];
    updatedEducation[index][field] = e.target.value;
    SetStudent({ ...student, education: updatedEducation });
  };

  const handleEditEducationClick = (index) => {
    setEditingEducationIndex(index);
  };

  const handleSaveEducationClick = () => {
    setEditingEducationIndex(null);
  };

  const handleAddEducationChange = (e, field) => {
    setNewEducation({ ...newEducation, [field]: e.target.value });
  };

  const handleAddEducation = () => {
    if (Object.values(newEducation).some(x => x === "")) return; // Prevent adding if any field is empty
    SetStudent({ ...student, education: [...student.education, newEducation] });
    setNewEducation({ institution: "", addr: "", duration: "", degree: "", desc: "" }); // Reset input fields
  };

  const handleDeleteEducation = (index) => {
    const updatedEducation = student.education.filter((_, i) => i !== index);
    SetStudent({ ...student, education: updatedEducation });
  };


  const handleProjectChange = (e, field, index) => {
    const updatedProjects = [...student.projects];
    updatedProjects[index][field] = e.target.value;
    SetStudent({ ...student, projects: updatedProjects });
  };

  const handleEditProjectClick = (index) => {
    setEditingProjectIndex(index);
  };

  const handleSaveProjectClick = () => {
    setEditingProjectIndex(null);
  };

  const handleAddProjectChange = (e, field) => {
    setNewProject({ ...newProject, [field]: e.target.value });
  };

  const handleAddProject = () => {
    if (newProject.name && newProject.description) {
      SetStudent({
        ...student,
        projects: [...student.projects, newProject],
      });
      setNewProject({ name: "", description: "" }); // Reset input fields
    }
  };

  const handleDeleteProject = (index) => {
    const updatedProjects = student.projects.filter((_, i) => i !== index);
    SetStudent({ ...student, projects: updatedProjects });
  };
  ///SKILL

  const handleSkillChange = (index) => {
    SetStudent((prev) => {
      const newSkills = [...prev.skills];
      newSkills[index].checked = !newSkills[index].checked;
      return { ...prev, skills: newSkills };
    });
  };

  const handleRatingChange = (index, value) => {
    SetStudent((prev) => {
      const newSkills = [...prev.skills];
      newSkills[index].rating = value;
      return { ...prev, skills: newSkills };
    });
  };

  const handleDeleteSkill = (index) => {
    SetStudent((prev) => {
      const newSkills = prev.skills.filter((_, i) => i !== index);
      return { ...prev, skills: newSkills };
    });
  };

  const handleAddSkill = () => {
    if (newSkill.name.trim() === "") return; // Prevent adding empty skill
    SetStudent((prev) => ({
      ...prev,
      skills: [...prev.skills, newSkill],
    }));
    setNewSkill({ name: "", rating: 0, checked: false }); // Reset new skill input
  };


  ///Interest

  const handleAddInterest = () => {
    if (newInterest.trim() === "") return; // Prevent adding empty interest
    SetStudent((prev) => ({
      ...prev,
      interests: [...prev.interests, newInterest],
    }));
    setNewInterest(""); // Clear input field
  };

  // Function to delete interest
  const handleDeleteInterest = (index) => {
    SetStudent((prev) => {
      const newInterests = prev.interests.filter((_, i) => i !== index);
      return { ...prev, interests: newInterests };
    });
  };

  const nameParts = student.name.split(" ");
  const firstName = nameParts[0];
  const lastName = nameParts.slice(1).join(" "); // Combine remaining parts as last nam
  return (<>
    <React.Fragment>
      <div className="page-content">
        <Breadcrumbs
          title="Dashboard"
          breadcrumbItem="Simple Resume"
        />

        <div class="containers">
          <div class="header">

            <div class="full-name">

              {editing.name ? (
                <InputGroup>
                  <Input
                    type="text"
                    value={student.name}
                    onChange={(e) => handleChange(e, 'name')}
                  />
                  <Button onClick={() => handleSaveClick('name')}>Save</Button>
                </InputGroup>
              ) : (
                <>
                  <span className="first-name">{firstName}</span>
                  <span className="last-name">{lastName}</span>
                  <i onClick={() => handleEditClick('name')} className="mdi mdi-pen"></i>

                </>
              )}

            </div>
            <div class="contact-info">
              <span class="email">Email: </span>
              <span class="email-val">
                {editing.email ? (
                  <InputGroup>
                    <Input
                      type="text"
                      value={student.email}
                      onChange={(e) => handleChange(e, 'email')}
                    />
                    <Button onClick={() => handleSaveClick('email')}>Save</Button>
                  </InputGroup>
                ) : (
                  <>
                    {student.email}

                    <i onClick={() => handleEditClick('email')} className="mdi mdi-pen"></i>
                  </>
                )}



              </span>
              <span class="separator"></span>
              <span class="phone">Phone: </span>
              <span class="phone-val">
                {editing.mob ? (
                  <InputGroup>
                    <Input
                      type="text"
                      value={student.phone}
                      onChange={(e) => handleChange(e, 'phone')}
                    />
                    <Button onClick={() => handleSaveClick('phone')}>Save</Button>
                  </InputGroup>
                ) : (
                  <>
                    {student.phone}

                    <i onClick={() => handleEditClick('phone')} className="mdi mdi-pen"></i>
                  </>
                )}



              </span>
            </div>

            <div class="about">
              <span class="position">
                {editing.position ? (
                  <InputGroup>
                    <Input
                      type="text"
                      value={student.position}
                      onChange={(e) => handleChange(e, 'position')}
                    />
                    <Button onClick={() => handleSaveClick('position')}>Save</Button>
                  </InputGroup>
                ) : (
                  <>
                    {student.position}

                    <i onClick={() => handleEditClick('position')} className="mdi mdi-pen"></i>
                  </>
                )}



              </span>
              <span class="desc">
                {editing.desc ? (
                  <InputGroup>
                    <Input
                      type="textarea"
                      value={student.desc}
                      onChange={(e) => handleChange(e, 'desc')}
                    />
                    <Button onClick={() => handleSaveClick('desc')}>Save</Button>
                  </InputGroup>
                ) : (
                  <>
                    {student.desc}

                    <i onClick={() => handleEditClick('desc')} className="mdi mdi-pen"></i>
                  </>
                )}

              </span>
            </div>
          </div>
          <div class="details">
            <div class="section">
              <div class="section__title">Experience</div>
              <div class="section__list">
                {student.experiences.map((exp, index) => (
                  <div className="section__list-item" key={index}>
                    <div className="left">
                      {editingIndex === index ? (
                        <>
                          <Input placeholder="Company" value={exp.company} onChange={(e) => handleExperienceChange(e, 'company', index)} />
                          <Input placeholder="Address" value={exp.addr} onChange={(e) => handleExperienceChange(e, 'addr', index)} />
                          <Input placeholder="Duration" value={exp.duration} onChange={(e) => handleExperienceChange(e, 'duration', index)} />
                        </>
                      ) : (
                        <>
                          <div className="name">{exp.company}</div>
                          <div className="addr">{exp.addr}</div>
                          <div className="duration">{exp.duration}</div>
                        </> 
                      )}
                    </div>
                    <div className="right">
                      {editingIndex === index ? (
                        <>
                          <Input placeholder="Role" value={exp.role} onChange={(e) => handleExperienceChange(e, 'role', index)} />
                          <Input placeholder="Description" value={exp.desc} onChange={(e) => handleExperienceChange(e, 'desc', index)} />
                          <Button onClick={handleSaveClickInd}>Save</Button>
                        </>
                      ) : (
                        <>
                          <div className="name">{exp.role}</div>
                          <div className="desc">{exp.desc}</div>
                          <i onClick={() => handleEditClickInd(index)} className="mdi mdi-pencil"></i>
                          <i onClick={() => handleDeleteExperience(index)} className="mdi mdi-delete text-danger"></i>
                        </>
                      )}
                    </div>
                  </div>
                ))}
                <div className="section__list-item">
                  <div className="left">
                    <Input placeholder="Company" value={newExperience.company} onChange={(e) => handleAddExperienceChange(e, 'company')} />
                    <Input placeholder="Address" value={newExperience.addr} onChange={(e) => handleAddExperienceChange(e, 'addr')} />
                    <Input placeholder="Duration" value={newExperience.duration} onChange={(e) => handleAddExperienceChange(e, 'duration')} />
                  </div>
                  <div className="right">
                    <Input placeholder="Role" value={newExperience.role} onChange={(e) => handleAddExperienceChange(e, 'role')} />
                    <Input placeholder="Description" value={newExperience.desc} onChange={(e) => handleAddExperienceChange(e, 'desc')} />
                    <Button onClick={handleAddExperience}>Add Experience</Button>
                  </div>
                </div>

              </div>

            </div>
            <div class="section">
              <div class="section__title">Education</div>
              <div class="section__list">
                {student.education.map((edu, index) => (
                  <div className="section__list-item" key={index}>
                    <div className="left">
                      {editingEducationIndex === index ? (
                        <>
                          <Input placeholder="Institution" value={edu.institution} onChange={(e) => handleEducationChange(e, 'institution', index)} />
                          <Input placeholder="Address" value={edu.addr} onChange={(e) => handleEducationChange(e, 'addr', index)} />
                          <Input placeholder="Duration" value={edu.duration} onChange={(e) => handleEducationChange(e, 'duration', index)} />
                        </>
                      ) : (
                        <>
                          <div className="name">{edu.institution}</div>
                          <div className="addr">{edu.addr}</div>
                          <div className="duration">{edu.duration}</div>
                        </>
                      )}
                    </div>
                    <div className="right">
                      {editingEducationIndex === index ? (
                        <>
                          <Input placeholder="Degree" value={edu.degree} onChange={(e) => handleEducationChange(e, 'degree', index)} />
                          <Input placeholder="Description" value={edu.desc} onChange={(e) => handleEducationChange(e, 'desc', index)} />
                          <Button onClick={handleSaveEducationClick}>Save</Button>
                        </>
                      ) : (
                        <>
                          <div className="name">{edu.degree}</div>
                          <div className="desc">{edu.desc}</div>
                          <i onClick={() => handleEditEducationClick(index)} className="mdi mdi-pencil"></i>
                          <i onClick={() => handleDeleteEducation(index)} className="mdi mdi-delete text-danger"></i>
                        </>
                      )}
                    </div>
                  </div>
                ))}
                <div className="section__list-item">
                  <div className="left">
                    <Input placeholder="Institution" value={newEducation.institution} onChange={(e) => handleAddEducationChange(e, 'institution')} />
                    <Input placeholder="Address" value={newEducation.addr} onChange={(e) => handleAddEducationChange(e, 'addr')} />
                    <Input placeholder="Duration" value={newEducation.duration} onChange={(e) => handleAddEducationChange(e, 'duration')} />
                  </div>
                  <div className="right">
                    <Input placeholder="Degree" value={newEducation.degree} onChange={(e) => handleAddEducationChange(e, 'degree')} />
                    <Input placeholder="Description" value={newEducation.desc} onChange={(e) => handleAddEducationChange(e, 'desc')} />
                    <Button onClick={handleAddEducation}>Add Education</Button>
                  </div>
                </div>
              </div>

            </div>
            <div class="section">
              <div class="section__title">Projects</div>
              <div class="section__list">
                {student.projects.map((project, index) => (
                  <div className="section__list-item" key={index}>
                    <div className="name">
                      {editingProjectIndex === index ? (
                        <Input
                          placeholder="Project Name"
                          value={project.name}
                          onChange={(e) => handleProjectChange(e, 'name', index)}
                        />
                      ) : (
                        project.name
                      )}
                    </div>
                    <div className="text">
                      {editingProjectIndex === index ? (
                        <>
                          <Input
                            placeholder="Description"
                            value={project.description}
                            onChange={(e) => handleProjectChange(e, 'description', index)}
                          />
                          <Button onClick={handleSaveProjectClick}>Save</Button>
                        </>
                      ) : (
                        <>
                          {project.description}
                          <i onClick={() => handleEditProjectClick(index)} className="mdi mdi-pencil"></i>
                          <i onClick={() => handleDeleteProject(index)} className="mdi mdi-delete text-danger"></i>
                        </>
                      )}
                    </div>
                  </div>
                ))}
                <div className="section__list-item">
                  <div className="name">
                    <Input
                      placeholder="Project Name"
                      value={newProject.name}
                      onChange={(e) => handleAddProjectChange(e, 'name')}
                    />
                  </div>
                  <div className="text">
                    <Input
                      placeholder="Description"
                      value={newProject.description}
                      onChange={(e) => handleAddProjectChange(e, 'description')}
                    />
                    <Button onClick={handleAddProject}>Add Project</Button>
                  </div>
                </div>
              </div>
            </div>
            <div class="section">
              <div class="section__title">Skills</div>
              <div class="skills">

                {student.skills.map((skill, index) => (
                  <div className="skills__item" key={index}>
                    <div className="left">
                      <label htmlFor={`ck${index + 1}`}>{skill.name}
                        <i onClick={() => handleDeleteSkill(index)} color="danger" className="mdi mdi-delete text-danger" size="sm"> </i></label>
                    </div>
                    <div className="right">
                      <div className="skill-rating">
                        {Array.from({ length: 5 }, (_, i) => (
                          <>
                            <input
                              id={`rating-${index}-${i + 1}`}
                              type="checkbox"
                              checked={skill.rating === i + 1}
                              onChange={() => handleRatingChange(index, i + 1)}
                            />
                            <label htmlFor={`rating-${index}-${i + 1}`}></label>
                          </>
                        ))}
                      </div>

                    </div>
                  </div>
                ))}


                {/* Add New Skill Form */}
                <div className="add-skill-form">
                  <Input
                    placeholder="New Skill Name"
                    value={newSkill.name}
                    onChange={(e) => setNewSkill({ ...newSkill, name: e.target.value })}
                  />
                  <Button onClick={handleAddSkill} color="primary">
                    Add Skill
                  </Button>
                </div>


              </div>


            </div>
            <div class="section">
              <div class="section__title">
                Interests
              </div>
              <div class="section__list">
                <div class="section__list-item">
                  {student.interests.map((interest, index) => (
                    <> {interest}
                      {index < student.interests.length - 1 && ", "}
                      <i
                        onClick={() => handleDeleteInterest(index)}
                        className="mdi mdi-delete text-danger ml-2"
                      ></i>
                    </>
                  ))}

                  <div className="add-interest-form">
                    <Input
                      placeholder="New Interest"
                      value={newInterest}
                      onChange={(e) => setNewInterest(e.target.value)}
                    />
                    <Button onClick={handleAddInterest} color="primary" className="mt-2">
                      Add Interest
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  </>)
}